import cx from 'clsx';
import * as React from 'react';
import { DeviceContext } from '../DeviceProvider/DeviceProvider';
import { GameClickProps } from '../modular-grid/types';

import { isActive } from './constants';
import styles from './HeaderSlot.module.scss';
import CommandItem from './items/CommandItem';
import ExternalItem from './items/ExternalItem';
import GameItem from './items/GameItem';
import InternalItem from './items/InternalLink';
import { HeaderItem } from './types';

export interface HeaderSlotProps {
  item: HeaderItem;
  onItemClick: (args: { title: string; route_link: string }) => void;
  onNavigationGameClick?: (args: {
    itemTitle: string;
    game: GameClickProps;
    sectionTitle: string;
    gamePosition: number;
  }) => void;
  onNavigationGameInfoClick?: (args: {
    itemTitle: string;
    game: GameClickProps;
    sectionTitle: string;
    gamePosition: number;
  }) => void;
  onNavigationCommandClick?: (args: {
    itemTitle: string;
    account?: string;
  }) => void;
  activeIndicatorColor?: string;
  index?: number;
  pageTitle?: string;
}

const HeaderSlot = ({
  item,
  onItemClick,
  onNavigationGameClick,
  onNavigationCommandClick,
  onNavigationGameInfoClick,
  activeIndicatorColor,
  index,
  pageTitle,
}: HeaderSlotProps) => {
  const { state, route_link, image, type } = item;
  const { deviceType, deviceOs } = React.useContext(DeviceContext);

  const renderHeaderItem = () => {
    if (route_link)
      return <InternalItem item={item} onInternalItemClick={onItemClick} />;
    switch (type) {
      case 'command':
        return (
          <CommandItem
            item={item}
            onCommandItemClick={onNavigationCommandClick}
          />
        );
      case 'external':
        return <ExternalItem item={item} />;

      case 'game_details':
      case 'game_launch':
        return (
          <GameItem
            item={item}
            deviceType={deviceType}
            deviceOs={deviceOs}
            pageTitle={pageTitle}
            index={index}
            onGameClick={onNavigationGameClick}
            onGameInfoClick={onNavigationGameInfoClick}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.headerSlot} data-testid="header-slot">
      <div
        className={cx(
          styles.icon,
          state === 'active' ? styles.iconActive : styles.iconInactive
        )}
        data-testid="icon"
        style={{
          maskImage: `url(${image.source})`,
          WebkitMaskImage: `url(${image.source})`,
        }}
        title={item.image_alt_text}
      ></div>
      {isActive(state) && (
        <div
          className={styles.selectionElement}
          data-testid="selection-element"
          style={
            activeIndicatorColor
              ? {
                  borderColor: `transparent transparent ${activeIndicatorColor} transparent`,
                }
              : {}
          }
        />
      )}
      {renderHeaderItem()}
    </div>
  );
};

export default HeaderSlot;
